import PropTypes from "prop-types";
import React from "react";
import { Button, FormControl } from "react-bootstrap";

import BudgetActions from "../actions/BudgetActions";

import CategoryStore from "../stores/CategoryStore";

import AccountingHelper from "../utils/AccountingHelper";

import CategorySelect from "./CategorySelect";
import InputAmount from "./InputAmount";
import ModalWrapper from "./ModalWrapper";

export default class BudgetAllocationEdit extends React.Component
{
	constructor(props)
	{
		super(props);

		this.state = {
			amount: 0,
			noteEdited: false,
			currency: null,
			numberDecimals: 2,
		};
		this.handleAmountChange = this.handleAmountChange.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
		this.handleFromCategoryChange = this.handleFromCategoryChange.bind(this);
		this.handleNoteChange = this.handleNoteChange.bind(this);
		this.handleSave = this.handleSave.bind(this);
		this.handleToCategoryChange = this.handleToCategoryChange.bind(this);
		this.setDefaultNoteText = this.setDefaultNoteText.bind(this);
	}

	async handleSave()
	{
		let currencyId = this.state.currency;
		let fromCategory = this.state.fromCategory;
		let toCategory = this.state.toCategory;
		let amount = this.state.amount;
		let note = this.state.note;

		// TODO: BA-154 don't allow fromCategory === toCategory, or amount <= 0

		await BudgetActions.transfer({
			currencyId,
			fromCategoryId: fromCategory,
			toCategoryId: toCategory,
			amount,
			note
		});

		// TODO: BA-159 consider waiting until finished
		this.handleClose();
	}

	handleClose()
	{
		this.props.onClose();
	}

	handleCurrencyChange(event)
	{
		let currency = +event.target.value;
		if (currency === 0)
		{
			currency = null;
		}
		const numberDecimals = AccountingHelper.getNumberDecimals(currency);
		this.setState({ currency, numberDecimals });
	}

	handleFromCategoryChange(category)
	{
		let categoryId = category ? category.id : null;
		this.setState({fromCategory: categoryId});
	}

	handleToCategoryChange(category)
	{
		let categoryId = category ? category.id : null;
		this.setState({toCategory: categoryId});
	}

	handleAmountChange(value)
	{
		this.setState({amount: value});
	}

	handleNoteChange(event)
	{
		this.setState({note: event.target.value, noteEdited: true});
	}

	setDefaultNoteText()
	{
		if (!this.state.noteEdited)
		{
			// Only do this if note is not set (if user has cleared it we don't want to reset it)
			const categories = CategoryStore.getCategories();
			const fromCategory = categories.find(cat => cat.id === this.state.fromCategory);
			const toCategory = categories.find(cat => cat.id === this.state.toCategory);
			if (fromCategory && toCategory)
			{
				this.setState({
					note: `${fromCategory.name} > ${toCategory.name}`
				});
			}
		}
	}

	render()
	{
		let categories = CategoryStore.getCategories();
		let currencies = this.props.currencies;
		let {currency, fromCategory, toCategory, numberDecimals} = this.state;
		let amount = this.state.amount;
		let note = this.state.note || "";
		let fromCategoryAmount = 0;
		if (fromCategory)
		{
			let fromBudgetItem = this.props.budgetItems.find(budgetItem => budgetItem.categoryId === fromCategory && budgetItem.currencyId === currency);
			if (fromBudgetItem)
			{
				fromCategoryAmount = fromBudgetItem.amount;
			}
		}
		let toCategoryAmount = 0;
		if (toCategory)
		{
			let toBudgetItem = this.props.budgetItems.find(budgetItem => budgetItem.categoryId === toCategory && budgetItem.currencyId === currency);
			if (toBudgetItem)
			{
				toCategoryAmount = toBudgetItem.amount;
			}
		}

		const footerElements = [
			<Button key={0} bsStyle={"primary"} onClick={this.handleSave}>Save</Button>,
			<Button key={1} onClick={this.handleClose}>Close</Button>
		];

		const showCurrencies = currencies && currencies.length > 0;

		return (
			<ModalWrapper
				title={"Budget Allocation Details"}
				modalClassName={"budget-allocation-modal"}
				footerElements={footerElements}
			>
				<div>
					{showCurrencies &&
						<div className={"form-group row"}>
							<label className={"col-sm-4"}>
								Currency
							</label>
							<div className={"col-sm-8"}>
								<FormControl
									id="moveMoneyCurrency"
									componentClass="select"
									placeholder="Currency"
									className="mousetrap-mod"
									onChange={this.handleCurrencyChange}
									value={currency || ""}
									autoFocus={showCurrencies}
								>
									<option></option>
									{currencies.map(currency => {
										return (
											<option key={currency.id} value={currency.id}>
												{currency.name}
											</option>
										);
									})}
								</FormControl>
							</div>
						</div>
					}
					<div className={"form-group row"}>
						<label className={"col-sm-4"}>
							From Category
						</label>
						<div className={"col-sm-8"}>
							<CategorySelect
								onSelect={this.handleFromCategoryChange}
								value={fromCategory}
								options={categories}
								autoFocus={!showCurrencies}
								budgetItems={this.props.budgetItems}
								onBlur={this.setDefaultNoteText}
								currencyId={currency}
							/>
							{fromCategory &&
								<span className="label label-info category-amount">{AccountingHelper.formatMoney(fromCategoryAmount, currency)}</span>
							}
						</div>
					</div>
					<div className={"form-group row"}>
						<label className={"col-sm-4"}>
							To Category
						</label>
						<div className={"col-sm-8"}>
							<CategorySelect
								onSelect={this.handleToCategoryChange}
								value={toCategory}
								options={categories}
								budgetItems={this.props.budgetItems}
								onBlur={this.setDefaultNoteText}
								currencyId={currency}
							/>
							{toCategory &&
								<span className="label label-info category-amount">{AccountingHelper.formatMoney(toCategoryAmount, currency)}</span>
							}
						</div>
					</div>
					<div className={"form-group row"}>
						<label className={"col-sm-4"}>
							Amount
						</label>
						<div className={"col-sm-8"}>
							<InputAmount
								pullRight={false}
								value={amount}
								onChange={this.handleAmountChange}
								numberDecimals={numberDecimals}
							/>
						</div>
					</div>
					<div className={"form-group row"}>
						<label className={"col-sm-4"}>
							Note
						</label>
						<div className={"col-sm-8"}>
							<FormControl
								type="text"
								bsClass="form-control input-sm"
								value={note}
								onChange={this.handleNoteChange}
							/>
						</div>
					</div>
				</div>
			</ModalWrapper>
		);
	}
}

BudgetAllocationEdit.propTypes = {
	onClose: PropTypes.func,
	budgetItems: PropTypes.arrayOf(
		PropTypes.shape({
			amount: PropTypes.number,
			categoryId: PropTypes.number
		})
	),
	currencies: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number,
			name: PropTypes.string
		})
	)
};



// WEBPACK FOOTER //
// ./Components/components/BudgetAllocationEdit.jsx